module.exports = __webpack_public_path__ + "static/media/6.e2e1bb7a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/6.jpg
// module id = 69
// module chunks = 0